import { CARD_DISPLAY_NAME } from './cardConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';
import { ElementType } from '../elements/elementTypes';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: ElementType.CARD_TYPE,
        content: {
            textContent: null,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: ElementType.CARD_TYPE,
        objectConstructorFn,
        displayName: CARD_DISPLAY_NAME,
        ...params,
    });
